import { all, call } from 'redux-saga/effects'
import { accountSaga } from './account/account.saga'
import { teamSaga } from './team/team.saga'
import { trainerSaga } from './trainer/trainer.saga'

export default function* rootSaga() {
    yield all([call(accountSaga), call(trainerSaga), call(teamSaga)])
}